import styled from "styled-components";

const ThumblineContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-wrap: nowrap;
    order: 1;
    height: calc(100% + 8px);
    margin: 0;
    width: 100px;
    overflow: hidden;
    // max-height: 380px;
    max-height: 500px;
    overflow: hidden;
    position: relative;
    .img-thumb-container-inner {
        overflow-y: scroll;
        position: absolute;
        max-height: 100%;
        top: 0;
        left: 0;
        height: 100%;
        width: calc(100% + 10px);
    }

    @media (max-width: 767px) {
        width: 70px;
    }
    @media (max-width: 575px) {
        display: none;
    }
    @media (max-width: 676px) {
        display: none;
    }
`;
export default ThumblineContainer;
